import React from 'react'

import brandIcon from 'assets/brand/navbar-brand-icon.png'
import wordmark from 'assets/brand/specialquiz-wordmark.svg'

interface Props {
  compact?: boolean
  subtitle?: string
}

const Brand = ({ compact = false, subtitle }: Props) => (
  <span className={`sq-brand${compact ? ' sq-brand--compact' : ''}`}>
    <img className="sq-brand__icon" src={brandIcon} alt="" />
    {!compact && (
      <span className="sq-brand__copy">
        <img className="sq-brand__wordmark" src={wordmark} alt="Special Quiz" />
        {subtitle && <span className="sq-brand__subtitle">{subtitle}</span>}
      </span>
    )}
  </span>
)

export default Brand
